import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import { RootState } from '@app/redux/root-reducer';
import { request } from '@app/services';
import * as endpoints from './endpoints';
import {
  addPortfolio,
  addPortfolioSuccess,
  addPortfolioFailed,
  getPortfolio,
  getPortfolioFailed,
  getPortfolioSuccess,
  deletePortfolio,
  deletePortfolioSuccess,
  deletePortfolioFailed,
  updatePortfolio,
  updatePortfolioSuccess,
  updatePortfolioFailed,
} from './slice';

function* addPortfolioSaga(action: ReturnType<typeof addPortfolio>): any {
  try {
    const { name, category, description, image, link } = action.payload;
    const formData = new FormData();
    formData.append('name', name);
    formData.append('category', category);
    formData.append('description', description);
    formData.append('image', image);
    formData.append('link', link);
    const result = yield call(request.post, endpoints.addPortfolio, formData);
    yield put(addPortfolioSuccess(result.data));
  } catch (err) {
    yield put(addPortfolioFailed(err));
  }
}
//
function* getPortfolioSaga(action: ReturnType<typeof getPortfolio>): any {
  try {
    const result = yield call(request.get, endpoints.getPortfolio);
    yield put(getPortfolioSuccess(result.data));
  } catch (err) {
    yield put(getPortfolioFailed(err));
  }
}
//
function* deletePortfolioSaga(action: ReturnType<typeof deletePortfolio>): any {
  try {
    const { id } = action.payload;
    const { data } = yield select((store: RootState) => store.portfolioReducer.portfolio);
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const result = yield call(request.delete, `${endpoints.deletePortfolio}${id}`);
    yield put(deletePortfolioSuccess(result.data));
    const updatedPortfolios = data?.filter((portfolio: { id: number }) => portfolio.id !== id);
    yield put(getPortfolioSuccess(updatedPortfolios));
  } catch (err) {
    yield put(deletePortfolioFailed(err));
  }
}
//
function* updatePortfolioSaga(action: ReturnType<typeof updatePortfolio>): any {
  try {
    const { id, name, category, description, image, link } = action.payload;
    const formData = new FormData();
    formData.append('id', id);
    formData.append('name', name);
    formData.append('category', category);
    formData.append('description', description);
    formData.append('image', image);
    formData.append('link', link);
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const result = yield call(request.put, `${endpoints.updatePortfolio}${id}`, formData);
    yield put(updatePortfolioSuccess(result.data.data));
  } catch (err) {
    yield put(updatePortfolioFailed(err));
  }
}
//

function* portfolioSagas() {
  yield all([
    takeLatest([getPortfolio, addPortfolioSuccess, updatePortfolioSuccess], getPortfolioSaga),
    takeLatest(addPortfolio, addPortfolioSaga),
    takeLatest(updatePortfolio, updatePortfolioSaga),
    takeLatest(deletePortfolio, deletePortfolioSaga),
  ]);
}
export { portfolioSagas };
